import React, { useCallback, memo } from 'react'
import PropTypes from 'prop-types'
import { Element } from 'react-scroll'

import FrequencySelect from 'Components/FrequencySelect'
import { FormElemGroup } from 'Components/Form'
import { MODAL_TYPE } from 'Defaults/modals'
import { frequencyToStringMap } from 'Defaults/inputData'
import TitleWithDelete from '../TitleWithDelete'
import FilterBar from '../FilterBar'
import ManageBuildings from '../ManageBuildings'

import {
  _BuildingAlertCard,
  _DeletingIndicator,
  _FrequencyGroup,
  _AddRecipient,
  _AddRecipientMulti,
  _AlertToggle,
  _FrequencySelect,
  _FrequencyContainer,
  _Title,
} from './styles'


const BuildingAlertCard = ({
  id,
  name,
  ccList,
  frequency,
  onRecipientChange,
  buildingIds,
  alert,
  updateAlert,
  filterStrings,
  deleteAlert,
  onFrequencyUpdate,
  openModal,
  deletingId,
}) => {
  const { alert_frequency: alertFrequency } = alert || {}

  function handleDeleteAlert(confirmMessageElem) {
    deleteAlert(id, confirmMessageElem)
  }

  const handleFrequency = useCallback(selected =>
    onFrequencyUpdate(alert, selected),
  )

  const handleRecipientChange = useCallback(recipients =>
    onRecipientChange(alert, recipients),
  )

  const toggleSwitch = () => {
    handleFrequency({ value: alertFrequency === 0 ? '1' : '0' })
  }


  const onEditClick = useCallback(() =>
    openModal({
      modalType: MODAL_TYPE.BUILDING_ALERT,
      modalData: {
        updateMode: true,
        targetAlert: alert,
      },
    }),
  )
  return (
    <_BuildingAlertCard>
      <Element name={id} id={`alertCard-${id}`} />
      {id === deletingId && <_DeletingIndicator />}
      <TitleWithDelete title={name} deleteAlert={handleDeleteAlert} />
      <FilterBar filterStrings={filterStrings} onEditClick={onEditClick} />
      <_FrequencyContainer>
        <_Title>Alert Emails & Notifications</_Title>
        <_FrequencyGroup marginBottomMag={1}>

          <_AlertToggle
            data-test-id={`buildingAlertSwitch-${id}`}
            inputId={`buildingAlertSwitch-${id}`}
            key={`buildingAlertSwitch-${id}`}
            isOn={alertFrequency !== 0}
            onChange={toggleSwitch}
            onLabel={'ON'}
            offLabel={'OFF'}
          >{alertFrequency !== 0 ? 'On' : 'Off'}
          </_AlertToggle>
          {
            alertFrequency !== 0 && (
              <_FrequencySelect>
                <FrequencySelect
                  title={frequencyToStringMap[frequency] || 'Daily'}
                  frequencyId={frequency}
                  onSelect={handleFrequency}
                  blurBackground={false}
                />
              </_FrequencySelect>
            )
          }
        </_FrequencyGroup>
      </_FrequencyContainer>
      <_AddRecipient>
        <FormElemGroup marginBottomMag={1}>
          <_AddRecipientMulti
            marginBottomMag={1}
            initCcList={ccList}
            onRecipientChange={handleRecipientChange}
          />
        </FormElemGroup>
      </_AddRecipient>
      <ManageBuildings
        updateAlert={updateAlert}
        buildingIds={buildingIds}
        alertId={id}
        alert={alert}
        handleDeleteAlert={handleDeleteAlert}
      />
    </_BuildingAlertCard>
  )
}
BuildingAlertCard.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  ccList: PropTypes.string,
  frequency: PropTypes.number,
  deletingId: PropTypes.string,
  onRecipientChange: PropTypes.func,
  buildingIds: PropTypes.arrayOf(PropTypes.number),
  alert: PropTypes.shape({}),
  updateAlert: PropTypes.func,
  filterStrings: PropTypes.shape({}),
  deleteAlert: PropTypes.func,
  openModal: PropTypes.func,
  onFrequencyUpdate: PropTypes.func,
}

export default memo(BuildingAlertCard)
